import { z } from 'zod'
import { baseModelShape } from '../baseModel'

export const workedHoursShape = {
  ...baseModelShape,
  id: z.string().uuid(),
  campaign: z.string().uuid(),
  campaign_name: z.string(),
  fundraiser: z.string().uuid(),
  worked_hours: z.number(),
  // success_donation_count: z.number(),
  lead_count: z.number(),
  fundrasier_full_name: z.string(),
  canvassing_org_name: z.string(),
  avg_age_recurring_donors: z.number(),
  avg_recurring_donation_amount: z.number(),
  count_recurring_donor_over_30: z.number(),
  location: z.string(),
  home_office: z.string(),
  datetime_created: z.string().refine((value) => !isNaN(Date.parse(value)), {
    message: 'Invalid date format',
  }),
  recurring_donation_count: z.number(),
  annual_donation_count: z.number().optional(),
  one_time_donation_count: z.number(),
  one_time_donation_sum: z.number(),
  stop_count: z.number().optional(),
}
export const updatedWorkedHourShape = {
  id: z.string(),
  worked_hours: z.number(),
}
export const FUNDRAISER_STATS_BY_DAY_FILTER_TYPE = 'FundraiserStatsByDayFilter'

/** Saved fundraiser + home-office filters on per-campaign Campaign Data. */
export const CAMPAIGN_DATA_FUNDRAISER_FILTER_TYPE = 'CampaignDataFundraiserFilter'

export const customRetrieveWorkedHourInputShape = {
  campaign: z.string().uuid(),
  date: z.string().refine((value) => !isNaN(Date.parse(value)), {
    message: 'Invalid date format',
  }),
}
export const customRetrieveAllWorkedHourInputShape = {
  canvassing_org: z.string().uuid().optional(),
  date: z.string().refine((value) => !isNaN(Date.parse(value)), {
    message: 'Invalid date format',
  }),
  campaign: z.string().optional(),
  fundraiser: z.string().optional(),
  home_office: z.string().optional(),
}

export const rangeRetrieveInputShape = {
  campaign: z.string().uuid(),
  start_date: z.string().refine((value) => !isNaN(Date.parse(value)), {
    message: 'Invalid date format',
  }),
  end_date: z.string().refine((value) => !isNaN(Date.parse(value)), {
    message: 'Invalid date format',
  }),
}

export const rangeRetrieveAllInputShape = {
  canvassing_org: z.string().uuid().optional(),
  start_date: z.string().refine((value) => !isNaN(Date.parse(value)), {
    message: 'Invalid date format',
  }),
  end_date: z.string().refine((value) => !isNaN(Date.parse(value)), {
    message: 'Invalid date format',
  }),
  campaign: z.string().optional(),
  fundraiser: z.string().optional(),
  home_office: z.string().optional(),
}

export const storeFundraiserStatsTemplateShape = {
  name: z.string(),
  filterType: z.string(),
  fields: z.array(z.string()),
  campaign: z.string().optional(),
  fundraiser: z.string().optional(),
  canvassingOrg: z.string().uuid().optional(),
  dateRangeStart: z.string().optional(),
  dateRangeEnd: z.string().optional(),
}

export const exportWorkedHoursTemplateShape = {
  fields: z.array(z.string()),
  campaign: z.string().optional(),
  fundraiser: z.string().optional(),
  canvassingOrg: z.string().uuid().optional(),
  dateRangeStart: z.string().optional(),
  dateRangeEnd: z.string().optional(),
}

export const removeFundraiserStatsTemplateShape = {
  templateId: z.string().uuid(),
}

export const canvassingOrgAdminChartInputShape = {
  start_date: z.string(),
  end_date: z.string(),
  campaign_filter_value: z.string(),
  fundraiser_filter_value: z.string().optional(),
}
export const deleteWorkedHourInputShape = {
  id: z.string().uuid(),
  campaign: z.string().uuid(),
  campaign_name: z.string(),
  fundraiser: z.string().uuid(),
  worked_hours: z.string(),
  // success_donation_count: z.number(),
  lead_count: z.number(),
  fundrasier_full_name: z.string().optional(),
  canvassing_org_name: z.string(),
  avg_age_recurring_donors: z.string(),
  avg_recurring_donation_amount: z.string(),
  count_recurring_donor_over_30: z.number(),
  location: z.string(),
  home_office: z.string(),
  datetime_created: z.string().refine((value) => !isNaN(Date.parse(value)), {
    message: 'Invalid date format',
  }),
  recurring_donation_count: z.number(),
  annual_donation_count: z.number().optional(),
  one_time_donation_count: z.number(),
  one_time_donation_sum: z.number(),
  stop_count: z.number().optional(),
}

export const stopCountRetrieveInputShape = {
  campaign: z.string().uuid(),
}

export const stopCountUpdateInputShape = {
  campaign: z.string().uuid(),
  delta: z
    .number()
    .int()
    .refine((value) => value === -1 || value === 1, {
      message: 'delta must be -1 or 1',
    }),
}
